var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleTickBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#1B6BC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.832 17.9997L17.9987 22.1663L26.332 13.833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1983 17.4697C9.90541 17.1768 9.43053 17.1768 9.13764 17.4697C8.84475 17.7626 8.84475 18.2374 9.13764 18.5303L10.1983 17.4697ZM13.3043 22.697C13.5972 22.9899 14.0721 22.9899 14.365 22.697C14.6579 22.4041 14.6579 21.9292 14.365 21.6363L13.3043 22.697ZM17.4697 17.4693C17.1768 17.7622 17.1768 18.2371 17.4697 18.53C17.7626 18.8229 18.2374 18.8229 18.5303 18.53L17.4697 17.4693ZM22.697 14.3633C22.9899 14.0704 22.9899 13.5956 22.697 13.3027C22.4041 13.0098 21.9292 13.0098 21.6363 13.3027L22.697 14.3633ZM9.13764 18.5303L13.3043 22.697L14.365 21.6363L10.1983 17.4697L9.13764 18.5303ZM18.5303 18.53L22.697 14.3633L21.6363 13.3027L17.4697 17.4693L18.5303 18.53Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTickBlue);
export default __webpack_public_path__ + "static/media/double-tick-blue.b29fd80a6cf5e63f1f1eda171d740e54.svg";
export { ForwardRef as ReactComponent };